import React, { useState } from "react";
import SortOverlay from "./SortOverlay";
let timeSetTimeout = null;

const TableHeader = (props) => {
  const [sortOverlay, setSortOverlay] = useState(null);
  const showSortOverlay = (event) => {
    if (window.innerWidth < 640) return;
    const el = event.currentTarget;
    clearTimeout(timeSetTimeout);
    setSortOverlay({
      id: el.dataset.index,
      height: el.offsetHeight,
      left: el.offsetLeft,
      dir:
        props.sortBy?.col === el.dataset.index ? props.sortBy?.direction : "",
    });
    timeSetTimeout = setTimeout(closeSortOverlayDelay, 1000);
  };
  const closeSortOverlayDelay = () => {
    timeSetTimeout = setTimeout(() => {
      setSortOverlay(null);
    }, 1000);
  };
  const closeSortOverlay = (event) => {
    const el = event.currentTarget;
    const sort = el.dataset.sort;
    const index = sortOverlay.id;

    if (sort === "unsort") {
      props.onSort(null);
    } else {
      props.onSort({ col: index, direction: sort });
    }
    setSortOverlay(null);
  };

  const onEnterOverlay = () => {
    clearTimeout(timeSetTimeout);
  };
  
  const changeSort=(event)=>{
    if (window.innerWidth >= 640) return;
    const elCol=event.currentTarget.dataset["index"];
    let sort=null;
    if (props.sortBy){
      if (props.sortBy.col == elCol){
        sort = (props.sortBy.direction==="asc" ? "desc" : null);
      }
      else{
        sort = "asc";
      }
    }
    else{
      sort = "asc";
    }

    if (sort){
      props.onSort({ col: elCol, direction: sort });
    }else{
      props.onSort(sort);
    }
  }

  return (
    <React.Fragment>
      {sortOverlay && (
        <SortOverlay
          overlayStyle={sortOverlay}
          keepOverlay={onEnterOverlay}
          closeOverlay={closeSortOverlay}
          closeOverlayDelay={closeSortOverlayDelay}
        />
      )}
      <div className="finderTable-table-header">
        {props.header
          .slice(0, props.config.numberColsVisible||1000)
          .map((cell, index) => {
            return (
              <div
                key={index}
                data-index={index}
                onMouseOver={showSortOverlay}
                onClick={changeSort}
                className={`${
                  props.sortBy
                    ? props.sortBy.col == index
                      ? props.sortBy.direction === "asc"
                        ? "asc"
                        : "desc"
                      : ""
                    : ""
                } ${'col' + index} finderTable-header-cell`}>
                 {cell && cell.h && <span dangerouslySetInnerHTML={{__html:cell.h}}/>} 
                <svg className={`finderTable-sort-btn-mobile ${props.sortBy && props.sortBy.col ==index && props.sortBy.direction=='asc' && 'asc'} ${props.sortBy && props.sortBy.col ==index && props.sortBy.direction=='desc' && 'desc'}`} version="1.1" x="0px" y="0px" viewBox="0 0 99.42 122.88"><g><path className="st0" d="M49.71,0L0,51.7c33.14,0,66.28,0,99.42,0L49.71,0L49.71,0z"/><path className="st1" d="M49.71,122.88L0,71.18c33.14,0,66.28,0,99.42,0"/></g></svg>
                <span className="finderTable-sort-btn">&#8942;</span>
              </div>
            );
          })}
        {props.config.numberColsVisible && (
          <div
            key={props.config.numberColsVisible}
            data-index={props.config.numberColsVisible}
            className={`${'col' + props.config.numberColsVisible} finderTable-header-cell finderTable-more-header-cell`}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default TableHeader;
